/* ================================================================
   Shop The Look — stl-dialog.js  ·  Machinist v8
   PORTAL: dialog body'e taşınır → stacking context sorunu çözülür
   ================================================================ */
(function () {
  'use strict';

  /* ── 1. Elemanları al ── */
  const dialog    = document.getElementById('stl-dialog');
  const panel     = document.getElementById('stl-panel');
  const openBtn   = document.getElementById('stl-open-btn');
  const closeBtn  = document.getElementById('stl-close-btn');
  const overlay   = document.getElementById('stl-overlay');
  const addAllBtn = document.getElementById('stl-add-all-btn');
  const wrapper   = document.getElementById('stl-trigger-wrapper');

  if (!dialog || !panel) return;

  const isMobile = () => window.innerWidth <= 768;

  /* ─────────────────────────────────────────────
     2. PORTAL — dialog'u body'e taşı
     Temanın stacking context'inden tamamen çıkar
  ───────────────────────────────────────────── */
  document.body.appendChild(dialog);

  /* ─────────────────────────────────────────────
     3. TRİGGER GALERİYE INJECT
     Desktop + mobil her ikisinde de
  ───────────────────────────────────────────── */
  function injectTrigger() {
    if (!wrapper) return;

    const selectors = [
      '.main-image',              /* Machinist v8 gerçek galeri kutusu (badge de buraya oturuyor) */
      '.product__media-wrapper',
      '.product__media',
      '.product-single__media-wrapper',
      '[data-product-media-wrapper]',
      '.product-images',
    ];

    let container = null;
    for (const sel of selectors) {
      container = document.querySelector(sel);
      if (container) break;
    }

    if (container) {
      /* inline style ile tema CSS'ini geç */
      container.style.setProperty('position', 'relative', 'important');
      container.style.setProperty('overflow', 'visible',  'important');
      container.appendChild(wrapper);
    }

    wrapper.style.display = 'block';
    /* Collapse yok — buton her zaman tam pill olarak kalır */
  }

  /* ─────────────────────────────────────────────
     4. DIALOG AÇ / KAPAT
  ───────────────────────────────────────────── */
  let scrollY = 0;

  function openDialog() {
    dialog.setAttribute('aria-hidden', 'false');
    /* scroll lock */
    scrollY = window.scrollY;
    document.body.style.overflow  = 'hidden';
    document.body.style.position  = 'fixed';
    document.body.style.top       = `-${scrollY}px`;
    document.body.style.width     = '100%';
    closeBtn?.focus();
  }

  function closeDialog() {
    dialog.setAttribute('aria-hidden', 'true');
    /* scroll unlock */
    document.body.style.overflow  = '';
    document.body.style.position  = '';
    document.body.style.top       = '';
    document.body.style.width     = '';
    window.scrollTo(0, scrollY);
    openBtn?.focus();
  }

  openBtn  && openBtn.addEventListener('click', openDialog);
  closeBtn && closeBtn.addEventListener('click', closeDialog);
  overlay  && overlay.addEventListener('click', closeDialog);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && dialog.getAttribute('aria-hidden') === 'false') closeDialog();
  });

  /* ─────────────────────────────────────────────
     5. CART GÜNCELLE
  ───────────────────────────────────────────── */
  function updateCartCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('cart-count, [data-cart-count]').forEach(el => {
      el.textContent       = count;
      el.dataset.cartCount = count;
    });
  }

  async function refreshAndOpenDrawer() {
    try {
      const root = window.Shopify?.routes?.root ?? '/';
      const r    = await fetch(root + '?sections=cart-drawer');
      if (!r.ok) throw 0;
      const s  = await r.json();
      const h  = s['cart-drawer'];
      if (h) {
        const doc = new DOMParser().parseFromString(h, 'text/html');
        const nd  = doc.querySelector('cart-drawer');
        const cd  = document.querySelector('cart-drawer');
        if (nd && cd) { cd.innerHTML = nd.innerHTML; cd.className = nd.className; }
      }
    } catch (_) {}

    const drawer = document.getElementById('CartDrawer') ?? document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open',   { bubbles: true }));
    if (drawer) {
      drawer.classList.remove('is-empty');
      ['active','is-open','menu-opening'].forEach(c => drawer.classList.add(c));
    }
  }

  /* ─────────────────────────────────────────────
     6. BEDEN SEÇİCİ
  ───────────────────────────────────────────── */
  dialog.addEventListener('change', e => {
    const sel = e.target.closest('.stl-card__size-select');
    if (!sel) return;
    const card  = sel.closest('.stl-card');
    const btn   = card.querySelector('.stl-card__add-btn');
    const opt   = sel.options[sel.selectedIndex];
    const avail = opt?.dataset.available === 'true';

    if (sel.value && avail) {
      btn.dataset.variantId = sel.value;
      btn.disabled = false;
      btn.querySelector('.stl-btn-text').textContent = 'Sepete Ekle';
      btn.classList.remove('is-error', 'is-success');
    } else if (sel.value && !avail) {
      btn.disabled = true;
      btn.querySelector('.stl-btn-text').textContent = 'Tükendi';
    } else {
      btn.disabled = true;
      btn.querySelector('.stl-btn-text').textContent = 'Beden Seçin';
    }
  });

  /* ─────────────────────────────────────────────
     7. TEK ÜRÜN — SEPETE EKLE
  ───────────────────────────────────────────── */
  dialog.addEventListener('click', async e => {
    const btn = e.target.closest('.stl-card__add-btn');
    if (!btn || btn.disabled || btn.id === 'stl-add-all-btn') return;

    const card = btn.closest('.stl-card');
    const sel  = card.querySelector('.stl-card__size-select');
    if (sel && !sel.value) {
      sel.style.borderColor = '#c0392b';
      sel.focus();
      setTimeout(() => { sel.style.borderColor = ''; }, 1500);
      return;
    }
    if (!btn.dataset.variantId) return;
    await addItem([{ id: btn.dataset.variantId, quantity: 1 }], btn);
  });

  /* ─────────────────────────────────────────────
     8. TÜM ÜRÜNLER — SEPETE EKLE
  ───────────────────────────────────────────── */
  addAllBtn && addAllBtn.addEventListener('click', async () => {
    const items = [];
    let err = false;

    dialog.querySelectorAll('.stl-card').forEach(card => {
      const sel    = card.querySelector('.stl-card__size-select');
      const hidden = card.querySelector('.stl-variant-input');
      const btn    = card.querySelector('.stl-card__add-btn');

      if (sel) {
        if (!sel.value) {
          sel.style.borderColor = '#c0392b';
          setTimeout(() => { sel.style.borderColor = ''; }, 1500);
          err = true; return;
        }
        if (sel.options[sel.selectedIndex]?.dataset.available === 'true')
          items.push({ id: sel.value, quantity: 1 });
      } else if (hidden?.dataset.available === 'true') {
        items.push({ id: hidden.value, quantity: 1 });
      } else if (btn && !btn.disabled && btn.dataset.variantId) {
        items.push({ id: btn.dataset.variantId, quantity: 1 });
      }
    });

    if (err || !items.length) return;

    addAllBtn.disabled    = true;
    addAllBtn.textContent = 'Ekleniyor…';

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (r.ok) {
        addAllBtn.textContent = 'Eklendi ✓';
        const cart = await fetch('/cart.js').then(x => x.json());
        updateCartCount(cart.item_count);
        closeDialog();
        await refreshAndOpenDrawer();
      } else {
        addAllBtn.textContent = 'Hata — tekrar dene';
        addAllBtn.disabled    = false;
      }
    } catch {
      addAllBtn.textContent = 'Hata — tekrar dene';
      addAllBtn.disabled    = false;
    }
  });

  /* ─────────────────────────────────────────────
     YARDIMCI: addItem
  ───────────────────────────────────────────── */
  async function addItem(items, btn) {
    const textEl = btn.querySelector('.stl-btn-text');
    const orig   = textEl?.textContent ?? '';
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (textEl) textEl.textContent = 'Ekleniyor…';

    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (r.ok) {
        btn.classList.replace('is-loading', 'is-success');
        if (textEl) textEl.textContent = 'Eklendi ✓';
        const cart = await fetch('/cart.js').then(x => x.json());
        updateCartCount(cart.item_count);
        setTimeout(async () => { closeDialog(); await refreshAndOpenDrawer(); }, 700);
        return true;
      }
      const d = await r.json().catch(() => ({}));
      btn.classList.replace('is-loading', 'is-error');
      if (textEl) textEl.textContent = d.description || 'Hata';
      setTimeout(() => { btn.classList.remove('is-error'); if (textEl) textEl.textContent = orig; btn.disabled = false; }, 2500);
    } catch {
      btn.classList.replace('is-loading', 'is-error');
      if (textEl) textEl.textContent = 'Hata';
      setTimeout(() => { btn.classList.remove('is-error'); if (textEl) textEl.textContent = orig; btn.disabled = false; }, 2500);
    }
    return false;
  }

  /* ── Başlat ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectTrigger);
  } else {
    injectTrigger();
  }

})();